import IntegratedAppOptions from 'integrated-app-embedder/IntegratedAppOptions';
import { PluginMessages } from './PluginMessages';
export default class PluginAppOptions extends IntegratedAppOptions {
  setPluginSettingsInit() {
    this.options.push({
      key: PluginMessages.PluginSettingsNavigation
    });
    return this;
  }
}